import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async fetchBaseRateSummaries (context, { includeProduction, includeWoodsSale, includeTransfer, includeLogYardSale }) {
    try {
      context.commit('setLoading', true)
      const url = ApiServer.urlFor(['contracts', 'baseratesummaries'], {
        params: { includeProduction, includeWoodsSale, includeTransfer, includeLogYardSale }
      })
      const response = await ApiServer.get(url)
      return response.data
    } finally {
      context.commit('setLoading', false)
    }
  },

  async fetchBaseRateSummary (_, contractId) {
    const url = ApiServer.urlFor(['contracts', contractId, 'baseratesummary'])
    const response = await ApiServer.get(url)
    return response.data
  },

  async addContractRateSheetLines (context, { contractId, activities }) {
    try {
      context.commit('setSaving', true)
      const url = ApiServer.urlFor(['contracts', contractId, 'ratesheetlines'])
      await ApiServer.post(url, { contractId, activities })
    } finally {
      context.commit('setSaving', false)
    }
  }
}
